import ComponentBase from "./component_base";
import UserDataManager from "../../../manager/user_manager";
import ModelData, { IUserData } from "../model_data";
import Utility from "../../../utility/utility";
import GameUtil from "../../../utility/game_util";
import AppData from "../const/app_data";
import PrefabsHolder from "./prefabsHolder";
import LoaclStorage from "../../../manager/local_storage";

const { ccclass, property } = cc._decorator;

@ccclass
export default class PublicPlayerAvatar extends ComponentBase {

    @property(cc.Label)
    labelName: cc.Label = null

    @property(cc.Label)
    labelGold: cc.Label = null

    @property(cc.Sprite)
    spriteAvatar: cc.Sprite = null

    @property(cc.Button)
    buttonAvatar: cc.Button = null

    @property(cc.Sprite)
    spriteHeadFrame: cc.Sprite = null

    @property(cc.Node)
    nodeAnimParent: cc.Node = null

    @property(cc.Prefab)
    animsPrefab: cc.Prefab = null

    get uid() {
        return this.m_uid
    }

    get coinBalance() {
        return this.m_coinBalance
    }

    get maxNameCharLen() {
        return this.mMaxNameCharLen
    }
    set maxNameCharLen(val) {
        this.mMaxNameCharLen = val
    }
    get isRankAvatar() {
        return this.m_isRankAvatar
    }
    set isRankAvatar(val) {
        this.m_isRankAvatar = val
    }

    protected m_coinBalance: number = 0
    protected mMaxNameCharLen: number = 8

    protected mCurAnim: cc.Node = null
    protected mAnimKeyMap: Map<string, cc.Node> = new Map<string, cc.Node>()

    protected mOnclickAvatarBtnCallback: Function = null

    protected m_uid: number = null

    protected m_prefabsHolder: PrefabsHolder = null

    protected m_isRankAvatar: boolean = false

    protected get prefabsHolder() {
        if (!this.m_prefabsHolder) {
            if (this.animsPrefab) {
                let node = cc.instantiate(this.animsPrefab)
                node.parent = this.node
                node.active = false
                this.m_prefabsHolder = node.getComponent(PrefabsHolder)
            }
        }
        return this.m_prefabsHolder
    }

    onLoad() {

        this.eventBind('player_avatar_data_changed', this.on_player_avatar_data_changed)
    }

    show(show: boolean, uid?: number) {
        this.node.active = show
        let self = this;
        this.reset()
        if (show && uid) {
            this.m_uid = uid
            this.showHeadFrame(true)
            this.updateAvatar(uid)
            if (self.buttonAvatar) {
                self.buttonAvatar.node.targetOff(self)
                self.buttonAvatar.node.on('click', function () {
                    self.mOnclickAvatarBtnCallback && self.mOnclickAvatarBtnCallback(this)
                }, self)
            }
        }

    }

    protected on_player_avatar_data_changed(uid: number, useRemote?: boolean) {
        if (uid == this.m_uid) {
            this.updateAvatar(uid, useRemote)
        }
    }

    updateAvatar(uid: number, useRemote?: boolean) {
        UserDataManager.getData(uid, (data: IUserData) => {
            if (this && this.isValid && this.m_uid == data.id) {
                this.refreshName(data.name)
                this.refreshAvatar(data.avatarSprite, uid)
                this.loadAnimByKey(data.plizedHeadFrame)
            }
        }, useRemote)
    }

    showHeadFrame(show: boolean) {
        this.spriteHeadFrame && (this.spriteHeadFrame.node.active = !!show)
    }

    refreshHeadFrame(spriteFrame: cc.SpriteFrame) {
        this.spriteHeadFrame && (this.spriteHeadFrame.spriteFrame = spriteFrame)
    }

    showCoinBalance(show: boolean) {
        this.labelGold && (this.labelGold.node.active = !!show)
    }

    refreshCoinBalance(coinBalance: number) {
        this.m_coinBalance = coinBalance
        this.labelGold && (this.labelGold.string = GameUtil.currencyFormatting(coinBalance))
    }

    setCoinBalanceColor(color: cc.Color) {
        this.labelGold.node.color = color
    }

    refreshName(name: string) {
        this.labelName && (this.labelName.string = Utility.filterPlayerName(name, this.maxNameCharLen))
    }

    refreshAvatar(spriteFrame: cc.SpriteFrame, uid?) {
        if (!this.spriteAvatar) {
            return
        }
        if (this.isRankAvatar) {
            if (AppData.startCheckGame) {
                let iconName = "101"
                if (uid != undefined) {
                    let str = "AvatarRankUserId" + uid
                    let localName = LoaclStorage.getString(str, "")
                    if (localName != "") {
                        iconName = localName
                    } else {
                        let gender = Math.random() < 0.5 ? 1 : 2
                        let index = Math.floor(Math.random() * 10 + 1)
                        iconName = gender + "0" + index
                        LoaclStorage.setString(str, iconName)
                    }
                }
                this.spriteAvatar.spriteFrame = ModelData.instance.getPlayerIconByName(iconName + ".png")
            } else {
                this.spriteAvatar.spriteFrame = spriteFrame
            }
        } else {
            this.spriteAvatar.spriteFrame = spriteFrame
        }
        // this.spriteAvatar && (this.spriteAvatar.spriteFrame = spriteFrame)
    }

    setClickAvatarBtnListener(callback) {
        this.mOnclickAvatarBtnCallback = callback
    }

    reset() {
        this.m_uid = null
        this.labelName && (this.labelName.string = '')
        this.spriteAvatar && (this.spriteAvatar.spriteFrame = null)
        this.buttonAvatar && this.buttonAvatar.node.targetOff(this)
    }

    getAnimNodeByKey(key: string) {
        let node = this.mAnimKeyMap.get(key)
        if (!node) {
            if (this.prefabsHolder) {
                node = this.prefabsHolder.getNodeByKey(key)
                if (node) {
                    this.mAnimKeyMap.set(key, node)
                }
            }
        }
        return node
    }

    loadAnimByKey(key: string) {
        if (!this.nodeAnimParent) {
            return
        }
        if (this.mCurAnim) {
            this.mCurAnim.active = false
            this.mCurAnim = null
        }
        key = key || ''
        let node = this.getAnimNodeByKey(key)
        if (!node) {
            return
        }
        this.mCurAnim = node
        node.active = true
        node.parent = this.nodeAnimParent
        node.position = cc.Vec3.ZERO
        node.scale = 1
    }
}